import { ActionTypes as types } from '../../constants'

/**
 * Block a payment due to its contingencies. For example, a High Risk scam warning.
 */
export function blockPayment() {
  const isBlocked = true
  return setBlockedPaymentAction(isBlocked)
}

/**
 * Block a payment due to its contingencies. For example, a High Risk scam warning.
 */
export function unBlockPayment() {
  const isBlocked = false
  return setBlockedPaymentAction(isBlocked)
}

/**
 * Store resolutions waiting for confirmation
 */
export function setPendingResolutionsAction(pendingResolutions) {
  return {
    type: types.TRANSACTION.SET_PENDING_RESOLUTIONS,
    data: { pendingResolutions },
  }
}

/**
 * Change the status of blocked payment
 */
export function setBlockedPaymentAction(isPaymentBlocked = false) {
  return {
    type: types.TRANSACTION.SET_PAYMENT_BLOCKED,
    data: { isPaymentBlocked },
  }
}

/**
 * Store the funding Id used to resolve contingencies.
 */
export function setContingencyFundingIdAction(contingencyFundingId) {
  return {
    type: types.TRANSACTION.SET_CONTINGECY_FUNDING_ID,
    data: { contingencyFundingId },
  }
}

/**
 * Set the type (risk level) of the scam warning. Used for rendering different warning overpanels.
 */
export function setScamWarningTypeAction(scamWarningType) {
  return {
    type: types.OVERPANELS.SET_SCAM_WARNING_TYPE,
    data: { scamWarningType },
  }
}

/**
 * Store resolver functions for Scam overpanel. Used so execution is halted by the overpanel.
 */
export function setScamResolvers({ resolve, reject }) {
  const scamResolvers = { resolve, reject }

  return {
    type: types.OVERPANELS.SET_SCAM_RESOLVERS,
    data: { scamResolvers },
  }
}
